import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InitializeAppService } from './services/initialize-app.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  
  constructor(
    appService: InitializeAppService,
  ) {
    appService.initializeApp();
  }
}
